// libs
import { connect } from 'react-redux';

// selectors
import { getProductId } from 'shared/store/details/selectors';

// components
import Image from './Image';

const mapStateToProps = (state: any) => ({
  productId: getProductId(state),
});

export default connect(mapStateToProps)(Image);
